import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formValueSelector } from 'redux-form';
import Form from '../../../components/forms/OfficialFormAdding';
import { breadcrumbs } from '../../../../../actions/appActions';
import { noop } from 'lodash';

const selector = formValueSelector('officialForm');

const mapStateToProps = (state, { params }) => ({
  workingPositions: selector(state, 'workingPositions') || [],
  statements: selector(state, 'statements') || [],
  visibility: selector(state, 'visibility'),
  breadcrumbsItems: [{ label: 'Funkcionář' }, { label: 'Detail funkcionáře' }],
  url: `/verejnost/api/funkcionari/${params.id}`,
  disabled: true,
  hasRequestStatement: selector(state, 'hasRequestStatement'),
  hasSecretStatement: selector(state, 'hasSecretStatement'),
  judge: selector(state, 'judge') || null,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({ breadcrumbs, onSubmit: noop }, dispatch),
  dispatch,
})

const ConnectedForm = connect(mapStateToProps, mapDispatchToProps)(Form);

export default (props) => (
  <ConnectedForm {...props} />
)
